
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Club </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm club section-banner-bg-1">
    <div class="container">
        <div class="text-center">
            <iframe src="https://drive.google.com/file/d/17OFi8WWivkw0GH4mGvN_wMJmC5Dymvbr/preview" height="600" width="800" class="iframe-sm"></iframe>
        </div>


    </div>
</section>
